// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"BreadCrumb-module__breadCrumb___pHwoU"};